export enum SystemReadyState {
    SYNCING_DATASTORE = "Syncing data. This may take up to a minute",
    SET_UP_USER_SESSION = "Retrieving team's data"
}
